export default __webpack_public_path__ + "static/media/goldCoin.41c092da.png";